/**
 * Client-side PDF name from bill.reference (spaces stripped), matching server naming.
 * Returns null if there is no usable reference (caller should use Content-Disposition).
 */
export function billPdfFileName(bill) {
  if (!bill || typeof bill.reference !== "string") {
    return null;
  }
  const stem = bill.reference
    .replace(/\s/g, "")
    .replace(/[^a-zA-Z0-9._-]/g, "");
  return stem ? `${stem}.pdf` : null;
}
